export default __webpack_public_path__ + "static/media/sources.3844e063.svg";